module.exports = __webpack_public_path__ + "img/103.98abd833.png";